<nav>
  <ul class="pagination justify-content-center">
    <li class="page-item" *ngIf="getPreviousPage()">
      <a class="page-link" href (click)="changePage($event, getPreviousPage())"  aria-label="Previous">
        <span aria-hidden="true">&laquo;</span>
      </a>
    </li>
    <li class="page-item" [ngClass]="{active:isCurrentPage(page)}" *ngFor="let page of getPages()">
      <a class="page-link" href (click)="changePage($event, page)">{{ page }}</a>
    </li>
    <li class="page-item" *ngIf="getNextPage()">
      <a class="page-link" href (click)="changePage($event, getNextPage())" aria-label="Next">
        <span aria-hidden="true">&raquo;</span>
      </a>
    </li>
  </ul>
</nav>
